import { getDateString } from "@/components/widgets/Revision/lib/helpers";
import type {
	RevisionExt,
	TableColumn,
} from "@/components/widgets/Revision/types";
import { ONE_YEAR_IN_MS } from "@/lib/utils";
import { getValueBy } from "../getValueBy";
import { todayData } from "../todayData";

export const chartData = (
	data: RevisionExt[],
	value: keyof TableColumn,
	timeFrame: string,
) => {
	if (!data || !data.length) {
		return [];
	}

	const today = todayData(data);
	const oneYearAgo = today ? today.date.getTime() - ONE_YEAR_IN_MS : 0;

	const filteredData = data.filter((item) => item.date.getTime() >= oneYearAgo);
	const dataIndex = filteredData.findIndex(
		(item) => getValueBy(value, timeFrame, item?.dp?.ns?.ee) != null,
	);

	if (dataIndex < 0) {
		return [];
	}

	return filteredData.slice(dataIndex).map((item) => {
		const timeFrameValue = Number(
			getValueBy(value, timeFrame, item?.dp?.ns?.ee),
		);
		return {
			time: getDateString(item.date),
			value: timeFrameValue >= 0 ? timeFrameValue : 0,
		};
	});
};
